import React from 'react';

const List = () => (
  <div>
    <h2>List page</h2>
    <p>
      This is the initial page. You'll see this page when navigate to React section from navbar.
    </p>
  </div>
);

export default List;
